import React from "react";
import { Button, Grid } from "antd";
import Icon from '@ant-design/icons';
import circleCheck from "assets/namespace/icons/circleCheck";
import "./UserOptionBtnComponent.scss";
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { IUserOptionBtnComponentProps } from "./UserOptionBtnInterfaces.types";

const { useBreakpoint } = Grid;

const CircleCheck = (props: Partial<CustomIconComponentProps>) =>
    <Icon component={circleCheck}{...props}
/>

function UserOptionBtnComponent(props: IUserOptionBtnComponentProps) {
  const screens = useBreakpoint();
  return (
    <div className={`UserOptionBtn ${props.className}`}>
      <Button 
        value={props.value}
        disabled={props.disabled}
        className={`btn ${props.disabled ? 'UserOptionBtn selected' : 'UserOptionBtn unselected'}  ${props.btnClassName}`}
        onClick={props.action}
        block = {screens['xs'] || screens['sm'] ? true : false}
        icon={<CircleCheck className={'UserOptionBtn'} style={{color:`${props.disabled ? '#FFFFFF' : '#004CC6'}`}} />}
        title={props.text}
      >
        {props.text}
      </Button>
    </div>
  );
}

export default UserOptionBtnComponent;
